import { Component, OnInit, Output, EventEmitter} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AppComponent } from "./app.component";
import { AppMainComponent } from "./app.main.component";
import { AppData } from "./core/data";
import { CoreMenu } from "./core/models";
import { LocalStorageService } from "./core/services/shared-services/local-storage.service";

@Component({
    selector: "app-menu",
    templateUrl: "./app.menu.component.html",
    styleUrls: ["./app.menu.component.scss"],
    standalone: false
})
export class AppMenuComponent implements OnInit {
    public model: any[];
    path: string;
    substription: any;
    existingMenus: any;

    constructor(
        public app: AppComponent,
        public appMain: AppMainComponent,
        private activatedRoute: ActivatedRoute,
        private appService: AppData
    ) { }

    ngOnInit() {
        var url = this.activatedRoute.snapshot["_routerState"].url;
        this.path = "admin";
        if (url != undefined && url != null && url.indexOf("selfcare") > 0) {
            this.path = "selfcare";
        }  
        this.populateManuItems()
    }

    populateManuItems() {
        this.substription = this.appService.getMenuItems(null).subscribe({
            next: (res: any) => {
                
                this.model = this.createMenuTree(res.data);
                
            },
        });
    }

    createMenuTree(dataset: CoreMenu[]) {
        const map = {};
        dataset?.sort((a, b) => (a.order > b.order ? 1 : -1));
        dataset.forEach((item) => (map[item.id] = item));
        const menuTree = [];
        dataset.forEach((item) => {
            item.label = item.title
            item.target = item.openInNewTab ? '_blank' : '_self'
            item.routerLink = item.url
            item.preventExact = item.exactMatch;
            if (item.parentId != 0) {
                item.icon = null;
                const parent = map[item.parentId];
                if (parent) {
                    parent.items = parent.items || [];
                    parent.items?.push(map[item.id]);
                } else {
                    // Parent menu isn't in this role's assigned set (orphan) — show the item
                    // at top level instead of crashing the entire navigation (map[undefined].items).
                    menuTree.push({ items: [map[item.id]] });
                }
            } else {
                menuTree.push({ items: [map[item.id]] });
            }
        });
        return menuTree;
    }

    @Output() toggleSidebar = new EventEmitter<void>();
    handleSidebarToggle(){
        this.toggleSidebar.emit()
    }
}
